module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-common', {
    attrs: {
      "type": "normal",
      "showAppTopLink": _vm.isSharePage,
      "showAppBotLink": _vm.isSharePage,
      "detail": _vm.data
    }
  }, [_c('div', {
    staticClass: "theme"
  }, [_c('div', {
    staticClass: "theme__top"
  }, [_c('div', {
    staticClass: "theme_header"
  }, [(_vm.data.headImage) ? _c('img', {
    staticClass: "bg_header_img",
    style: ('background:#F6F6F6'),
    attrs: {
      "src": _vm.data.headImage
    },
    on: {
      "load": _vm.loadImg
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "theme_header_tip"
  }, [_c('span', {
    staticClass: "tip"
  }, [_vm._v("#话题")]), _vm._v(" "), _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.data.hits)), _c('span', {
    staticClass: "num_tip"
  }, [_vm._v("人参与讨论")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "title-area"
  }, [_c('h3', [_vm._v(_vm._s(_vm.data.viewType == 'bigimage' ? (_vm.data.showTitle ? _vm.data.title : '') : (_vm.data.showTitle ? _vm.data.listTitle : _vm.data.title)))]), _vm._v(" "), _c('div', {
    staticClass: "description_content"
  }, [_c('div', {
    class: _vm.isHideDescFlag ? 'description mult_line_ellipsis' : 'description',
    domProps: {
      "innerHTML": _vm._s(_vm.data.description && _vm.data.description.replace(/(\r\n|\n|\r)/gm, '<br />'))
    }
  }), _vm._v(" "), (_vm.isNeedUnfold) ? _c('div', {
    class: _vm.isHideDescFlag ? 'unfold' : 'fold',
    on: {
      "click": _vm.unfold
    }
  }, [_vm._v(_vm._s(_vm.unfoldText) + " "), _c('span', {
    staticClass: "arrow-down"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.data.hasVote) ? _c('PageVote', {
    attrs: {
      "voteObj": _vm.data
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('theme-list', {
    attrs: {
      "sysCode": _vm.data.sysCode
    },
    on: {
      "on-openApp": _vm.openDialog
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-413b1732!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-theme.vue
// module id = 846
// module chunks = 2